import { styled, Tooltip } from "@mui/material";
import { actionBarName } from "../classes.js";
const MenuTooltip = styled(Tooltip, {
  name: actionBarName,
  overridesResolver: (_props, styles) => styles.menuTooltip,
  slot: "MenuTooltip"
})``;
export {
  MenuTooltip
};
//# sourceMappingURL=MenuTooltip.js.map
